import React, {useContext, useEffect, useRef, useState} from 'react';
import styles from '../Filter/Filter.module.scss'
import Button from "../../../elements/Button/Button";
import Icon from "../../../elements/Icon/Icon";
import {useSelector} from "react-redux";
import Select from "../../../elements/Select/Select";
import {AppContext} from "../../../../context/AppContext";

const DateFilter = ({isDesktop}) => {
    const {changeFilter} = useContext(AppContext);
    const {invoices} = useSelector((state) => state.invoices);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const [yearOptions, setYearOptions] = useState([]);

    const ref = useRef();

    const toggleFilterList = () => {
        setIsFilterOpen(!isFilterOpen);
    };

    const handleUpdateFilter = () => {
        if (selectedYear) {
            const filterValue = selectedMonth
                ? `${selectedYear}-${selectedMonth}`
                : `${selectedYear}-00`;
            changeFilter('month', filterValue);
        }

        setIsFilterOpen(false);
    };

    const handleClearFilter = () => {
        const currentYear = new Date().getFullYear().toString();
        setSelectedMonth('');
        setSelectedYear('');
        changeFilter('month', `${currentYear}-00`);
        setIsFilterOpen(false);
    }

    const monthOptions = [
        {value: '01', label: 'January'},
        {value: '02', label: 'February'},
        {value: '03', label: 'March'},
        {value: '04', label: 'April'},
        {value: '05', label: 'May'},
        {value: '06', label: 'June'},
        {value: '07', label: 'July'},
        {value: '08', label: 'August'},
        {value: '09', label: 'September'},
        {value: '10', label: 'October'},
        {value: '11', label: 'November'},
        {value: '12', label: 'December'},
    ];

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        };

        isFilterOpen &&
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isFilterOpen]);

    useEffect(() => {
        if (invoices) {
            const years = Array.from(
                new Set(invoices.map((invoice) => new Date(invoice.createdAt).getFullYear()))
            ).sort((a, b) => a - b);

            const currentYear = new Date().getFullYear();

            if (!years.includes(currentYear)) {
                years.push(currentYear);
                years.sort((a, b) => a - b);
            }

            setYearOptions(years.map((year) => ({ value: year.toString(), label: year.toString() })));
            setSelectedYear(currentYear.toString());
        }
    }, [invoices]);

    return (
        <div className={styles.filter} ref={ref}>
            <Button className={styles.filterButton} onClick={toggleFilterList}>
                Filter {isDesktop && 'by month'}
                <Icon
                    name="arrow-down"
                    size={11}
                    color={'var(--color-teal)'}
                    customStyle={{
                        transition: 'transform 350ms ease-in-out',
                    }}
                />
            </Button>
            {isFilterOpen && (
                <div className={styles.list}>
                    <Select
                        value={selectedMonth}
                        onChange={(value) => setSelectedMonth(value)}
                        options={monthOptions}
                        placeholder="Month"
                    />

                    <Select
                        value={selectedYear}
                        onChange={(value) => setSelectedYear(value)}
                        options={yearOptions.map((year) => ({value: year.value, label: year.value}))}
                        placeholder="Year"
                    />
                    <div style={{display: 'flex'}}>
                        <Button className='primary' onClick={handleUpdateFilter} disabled={!selectedYear}>Apply</Button>
                        <Button onClick={handleClearFilter}>Clear</Button>
                    </div>
                </div>
            )}
        </div>
    )
        ;
};

export default DateFilter;
